// extracted by mini-css-extract-plugin
module.exports = {"md":"news-popup_md_3ZbUj","ios":"news-popup_ios_2Abn4","date":"news-popup_date_cMFV7"};